import { Grid } from "@octopus-energy/coral/atoms"
import { type SbBlogPostStory } from "@/features/storyblok"
import { BlogPostPreview } from "./BlogPostPreview"

type BlogStoriesProps = {
    stories: SbBlogPostStory[]
}

export function BlogStories({ stories }: BlogStoriesProps) {
    return (
        <Grid
            gap="sm"
            gridTemplateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
        >
            {stories.map((story) => (
                <BlogPostPreview
                    story={story}
                    key={story.uuid}
                />
            ))}
        </Grid>
    )
}
